import template from './tsz-loading.html';
import './tsz-loading.styl';

export default {
  template,
};



// WEBPACK FOOTER //
// ./src/components/tsz-loading/tsz-loading.js